import * as React from 'react';

import { ITagGroup, IAddProps } from '../types';
import Form from './Form';

export default class Add extends React.Component<IAddProps> {
  onSubmit = async (values: ITagGroup) => {
    await this.props.add(values);
    this.props.close();
  };

  render() {
    return (
      <Form
        id="new"
        initialValues={{
          allowDuplicateOnItemLevel: 'AllowDuplicate',
          allowDuplicateOnParameterLevel: 'AllowDuplicate',
          allowDuplicateInSystem: 'AllowDuplicate',
          regexMatch: null,
          name: '',
        }}
        onSubmit={this.onSubmit}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/TagGroups/components/New.tsx